import { render } from "./ParkingGroupLegend.vue?vue&type=template&id=59ba1dc4&scoped=true&ts=true"
import script from "./ParkingGroupLegend.vue?vue&type=script&lang=ts"
export * from "./ParkingGroupLegend.vue?vue&type=script&lang=ts"

import "./ParkingGroupLegend.vue?vue&type=style&index=0&id=59ba1dc4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ba1dc4"]])

export default __exports__